import { FC } from 'react';
import { RoadsideFeatureTable } from '../roadside-feature-table';
import { WidgetProps } from '../widget-block';

const RoadsideUltimateFeatureTable: FC<WidgetProps> = ({ anchor }) => {
  return (
    <RoadsideFeatureTable
      features={[
        {
          type: '24Hour',
          title: '24-hour Roadside Assist',
          description:
            'Your roadside cover includes 24 hour a day help Australia wide. Giving you everyday protection against breakdowns.',
        },
        {
          type: 'personalCover',
          title: 'Personal cover',
          description:
            'Our roadside cover applies to the individual, so you’re covered for any vehicle you are travelling in at the time of breakdown. Be sure to check out Group cover if there is more than one of you!',
        },
        {
          type: 'towingMetro',
          title: 'Towing - Metro (under 3.5 tonnes)',
          description:
            'If we can’t get your car on the road, we will arrange a tow. This can be to your home or a repairer of your choice, up to the distance approved. We can go further, but there will be excess fees.',
        },
        {
          type: 'towingCountry',
          title: 'Towing - Country (under 3.5 tonnes)',
          description:
            'If we can’t get your car on the road, we will arrange a tow. This can be to your home or a repairer of your choice, up to the distance approved. We can go further, but there will be excess fees.',
        },
        {
          type: 'flatBattery',
          title: 'Flat battery',
          description: `If your car won’t start as you have a flat or faulty battery, we can offer a jump start or to install a new battery. As a member you’ll receive a free battery test and a discount off a new battery with us. Find out more on our `,
          link: {
            url: '/cars-and-driving/batteries',
            label: 'batteries page',
          },
        },
        {
          type: 'flatTyre',
          title: 'Flat tyre',
          description:
            'If you’ve got a suitable spare, we’ll change the wheel for you when you have a flat or damaged tyre.',
        },
        {
          type: 'outOfFuel',
          title: 'Out of fuel',
          description: 'If you run out of fuel, we can bring enough to get you to the nearest service station.',
        },
        {
          type: 'lockOuts',
          title: 'Lock outs',
          description: 'If you’ve locked your keys in the car, we’ll do our best to get your car unlocked.',
        },
        {
          type: 'bicycleAssist',
          title: 'Bicycle assist',
          description:
            'We’ll come to you if your bicycle can’t be ridden due to a crash, mechanical problem or puncture. If we can’t get you back on the road, we will give you and your bike a lift to where you’re going.*',
        },
        {
          type: 'caravanOrTrailerTowing',
          title: 'Caravan or trailer towing',
          description:
            'We can tow caravans or trailers either attached or disabled from your car. Maximum size & weight limits apply.',
        },
        {
          type: 'locksmith',
          title: 'Locksmith',
          description:
            'If we can’t get your car unlocked, we’ll call a locksmith and contribute up to $165 towards the cost.',
        },
        {
          type: 'passengerTransport',
          title: 'Passenger transport after tow',
          description:
            'If you need towing after a breakdown, we can get you to your destination. If we have a larger tow truck with us, we can bring 4 passengers as well.',
        },
        {
          type: 'secondTow',
          title: 'Second tow',
          description:
            'If we can’t get you to the repairer of your choice on the first tow, we will provide one more local tow if needed.',
        },
        {
          type: 'heavyVehicleTowing',
          title: 'Heavy vehicle towing (over 3.5 tonne)',
          description:
            'We can arrange special towing equipment if your car exceeds weight and size limits. We’ll also reimburse you up to $200 towards the cost.',
        },
        {
          type: 'heavyVehicleWheelChange',
          title: 'Heavy vehicle wheel change',
          description:
            'We’ll pay up to $150 towards special equipment needed to change tyres due to weight restrictions.',
        },
        {
          type: 'interstateCoverage',
          title: 'Interstate coverage',
          description:
            'You’re covered anywhere in Australia. Call us on 13 11 11 and we’ll arrange emergency roadside assistance for you.',
        },
        {
          type: 'overseasCoverage',
          title: 'Overseas coverage',
          description:
            'We’re part of a large network of auto clubs around the world that look after our members. Benefits will differ depending on the country you’re visiting',
        },
        {
          type: 'hireCar',
          title: 'Hire car for major breakdowns',
          description:
            'If your car needs major mechanical repair that will take longer than 7 days, we’ll arrange a hire car for you. To qualify the repairs must be through our AutoServe or a Registered Automotive Repair Centre.',
        },
        {
          type: 'majorBreakdownBenefits',
          title: 'Major breakdown benefits',
          description:
            'When you’re more than 50km from home and your car needs major repairs that will take longer than 48hrs to fix, we can help. We can arrange accommodation, car hire, transport or towing.',
        },
      ]}
      product={{
        title: 'Ultimate',
        icon: 'shield-check',
        price: {
          monthly: '20.50',
          annual: '246',
        },
        isFeatured: true,
        featuredLabel: 'Most popular',
        url: 'https://roadside.ract.com.au',
        features: [
          {
            type: '24Hour',
            isIncluded: true,
            conditions: 'Up to $5,000 in benefits per year',
          },
          {
            type: 'personalCover',
            isIncluded: true,
          },
          {
            type: 'towingMetro',
            isIncluded: true,
            conditions: 'Unlimited*',
          },
          {
            type: 'towingCountry',
            isIncluded: true,
            conditions: 'Unlimited*',
          },
          {
            type: 'flatBattery',
            isIncluded: true,
          },
          {
            type: 'flatTyre',
            isIncluded: true,
          },
          {
            type: 'outOfFuel',
            isIncluded: true,
            conditions: 'We will give you up to 10l free',
          },
          {
            type: 'lockOuts',
            isIncluded: true,
          },
          {
            type: 'bicycleAssist',
            isIncluded: true,
          },
          {
            type: 'caravanOrTrailerTowing',
            isIncluded: true,
          },
          {
            type: 'locksmith',
            isIncluded: true,
          },
          {
            type: 'passengerTransport',
            isIncluded: true,
          },
          {
            type: 'secondTow',
            isIncluded: true,
          },
          {
            type: 'heavyVehicleTowing',
            isIncluded: true,
          },
          {
            type: 'heavyVehicleWheelChange',
            isIncluded: true,
          },
          {
            type: 'interstateCoverage',
            isIncluded: true,
          },
          {
            type: 'overseasCoverage',
            isIncluded: true,
          },
          {
            type: 'hireCar',
            isIncluded: true,
            conditions: 'Up to 3 days, $300 a year*',
          },
          {
            type: 'majorBreakdownBenefits',
            isIncluded: true,
          },
        ],
      }}
      anchor={anchor}
    />
  );
};

export { RoadsideUltimateFeatureTable };
